var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5.40137H17V4.40137C17 2.70137 15.7 1.40137 14 1.40137H10C8.3 1.40137 7 2.70137 7 4.40137V5.40137H3C2.4 5.40137 2 5.80137 2 6.40137C2 7.00137 2.4 7.40137 3 7.40137H4V20.4014C4 22.1014 5.3 23.4014 7 23.4014H17C18.7 23.4014 20 22.1014 20 20.4014V7.40137H21C21.6 7.40137 22 7.00137 22 6.40137C22 5.80137 21.6 5.40137 21 5.40137ZM9 4.40137C9 3.80137 9.4 3.40137 10 3.40137H14C14.6 3.40137 15 3.80137 15 4.40137V5.40137H9V4.40137ZM17 21.4014C17.6 21.4014 18 21.0014 18 20.4014V7.40137H6V20.4014C6 21.0014 6.4 21.4014 7 21.4014H17ZM11 11.4014V17.4014C11 18.0014 10.6 18.4014 10 18.4014C9.4 18.4014 9 18.0014 9 17.4014V11.4014C9 10.8014 9.4 10.4014 10 10.4014C10.6 10.4014 11 10.8014 11 11.4014ZM15 17.4014V11.4014C15 10.8014 14.6 10.4014 14 10.4014C13.4 10.4014 13 10.8014 13 11.4014V17.4014C13 18.0014 13.4 18.4014 14 18.4014C14.6 18.4014 15 18.0014 15 17.4014Z",
    fill: "#EA5455"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSvg);
export default __webpack_public_path__ + "static/media/trash-svg.1ae0ac505844ee6c6adcfc5fa351698d.svg";
export { ForwardRef as ReactComponent };